<template>
  <BreadCrumb PageTitle="Reception Colis" />
  <ListeNotes />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ListeNotes from "@/components/Notes/Reception/ListeNotes.vue";

export default defineComponent({
  name: "ListePage",
  components: {
    BreadCrumb,
    ListeNotes,
  },
});
</script>